import { render, staticRenderFns } from "./limitReport.vue?vue&type=template&id=3304fe1e"
import script from "./limitReport.vue?vue&type=script&lang=js"
export * from "./limitReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports